import { render, staticRenderFns } from "./actualizacion-y-recargos.vue?vue&type=template&id=22b57d59&lang=html&"
import script from "./actualizacion-y-recargos.vue?vue&type=script&lang=js&"
export * from "./actualizacion-y-recargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports